const STRIPE_CONNECT_CLIENT_ID = 'ca_Io0YIoMz0EuwSVLxRk0V7w4haljMV7yx';

export const getStripeConnectLink = (email, state) => {
    return `https://connect.stripe.com/express/oauth/authorize?client_id=${STRIPE_CONNECT_CLIENT_ID}&state=${state}&stripe_user[business_type]=individual&stripe_user[email]=${email}&stripe_user[url]=${encodeURI(
        `${window.location.origin}/profile/${state}`
    )}&redirect_uri=${window.location.origin}/stripe/redirect`;
};
